import { render, staticRenderFns } from "./LumbreApp.vue?vue&type=template&id=4369bd42&scoped=true"
import script from "./LumbreApp.vue?vue&type=script&lang=js"
export * from "./LumbreApp.vue?vue&type=script&lang=js"
import style0 from "./LumbreApp.vue?vue&type=style&index=0&id=4369bd42&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369bd42",
  null
  
)

export default component.exports